import { render, staticRenderFns } from "./TransactionsHistory.vue?vue&type=template&id=048301ac"
import script from "./TransactionsHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionsHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports